import AuthError from './components/AuthError';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';

export default function App() {
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/reset-password';

  if (pathname === '/auth/error') return <AuthError />;
  if (pathname === '/verify-email') return <VerifyEmail />;

  return <ResetPassword />;
}
